var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0958 33.7397L30.0943 36.7412C29.4606 37.3749 28.5602 37.6583 27.4596 37.6583C23.8578 37.6583 18.0716 34.4567 12.7856 29.2208L12.7189 29.1541C12.7189 29.1541 12.6689 29.1041 12.6522 29.0874C5.81549 22.184 2.44715 14.4634 5.13182 11.7788L8.11664 8.77728C9.00041 7.91018 10.4178 7.91018 11.2849 8.77728L14.6032 12.0956C15.487 12.9794 15.487 14.3967 14.6032 15.2638L12.1687 17.6984C11.1348 18.7322 13.0024 22.234 16.3207 25.5523C19.6391 28.8706 23.1408 30.7216 24.1746 29.7044L26.6092 27.2698C27.4763 26.3861 28.8937 26.3861 29.7608 27.2698L33.0958 30.5882C33.9629 31.4553 33.9629 32.8726 33.0958 33.7397Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallusIcon);
export default __webpack_public_path__ + "static/media/callusIcon.5b58f1ee2015d092d596abdfdb1f8c52.svg";
export { ForwardRef as ReactComponent };